import { render, staticRenderFns } from "./VendorSubAccounts.vue?vue&type=template&id=3781b5e2&scoped=true&"
import script from "./VendorSubAccounts.vue?vue&type=script&lang=js&"
export * from "./VendorSubAccounts.vue?vue&type=script&lang=js&"
import style0 from "./VendorSubAccounts.vue?vue&type=style&index=0&id=3781b5e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3781b5e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3781b5e2')) {
      api.createRecord('3781b5e2', component.options)
    } else {
      api.reload('3781b5e2', component.options)
    }
    module.hot.accept("./VendorSubAccounts.vue?vue&type=template&id=3781b5e2&scoped=true&", function () {
      api.rerender('3781b5e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/vendors/VendorSubAccounts.vue"
export default component.exports